// removed by extract-text-webpack-plugin
module.exports = {"showMoreWrapper":"_1ED4V0stfSJCHSBvSgEirs","collapsed":"_3Z0YrgZB_zPuvcRDGZUlcN","hidden":"_3vEs30Tt-l8ZZtF_1A5Y8m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowMore/ShowMore.scss
// module id = 1775
// module chunks = 0